import { toCurrency } from '@fastre/core/helperFunctions/string'
import { InternalAgentPayroll, InternalAgentStatement } from '@fastre/core/schemas/agentStatement'
import { KeyboardArrowDown, KeyboardArrowRight } from '@mui/icons-material'
import { Box, Table } from '@mui/joy'
import { useApi } from 'api'
import { usePayrollApi } from 'apiProviders'
import Loading from 'components/Loading'
import { format } from 'date-fns'
import { useState } from 'react'
import { useParams } from 'react-router'
import AgentStatementRow from './agentStatement/agentStatementRow'

const PayrollRow = ({ payroll }: { payroll: InternalAgentPayroll }) => {
    const { userId } = useParams<{ userId: string }>()
    const api = useApi()
    const [expanded, setExpanded] = useState(false)
    const [payrollItems, setPayrollItems] = useState<InternalAgentStatement[]>()
    const [loading, setLoading] = useState(false)

    const fetchPayrollDetails = async () => {
        if (!expanded && !payrollItems) {
            setLoading(true)
            try {
                const data = await api.post('/getpayroll', {
                    userId,
                    payrollId: payroll.id,
                })
                setPayrollItems(data.data)
            } catch (error) {
                console.error('Failed to fetch payroll details:', error)
            } finally {
                setLoading(false)
            }
        }
    }

    const handleToggle = () => {
        setExpanded(!expanded)
        if (!expanded) {
            fetchPayrollDetails()
        }
    }

    return (
        <>
            <tr
                key={payroll.id}
                onClick={handleToggle}
                style={{ cursor: 'pointer' }}
            >
                <td>
                    <Box
                        component="span"
                        sx={{ mr: 2 }}
                    >
                        {expanded ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
                    </Box>
                    {format(payroll.paySlipDate, 'dd/MM/yy')}
                </td>
                <td>{toCurrency(payroll.creditAmount)}</td>
                <td>{toCurrency(payroll.debitAmount)}</td>
                <td>
                    <b>{toCurrency(payroll.totalAmount)}</b>
                </td>
            </tr>
            {expanded && (
                <Box
                    component="tr"
                    sx={{
                        '&:hover': {
                            backgroundColor: 'transparent !important',
                        },
                    }}
                >
                    <td
                        colSpan={4}
                        style={{ padding: 0, border: 'none' }}
                    >
                        <Box
                            component="div"
                            sx={{ p: 2 }}
                        >
                            {loading ? (
                                <Loading />
                            ) : payrollItems ? (
                                <Table
                                    hoverRow={false}
                                    sx={{
                                        '& tbody tr:hover': {
                                            backgroundColor: 'transparent !important',
                                        },
                                    }}
                                >
                                    <thead>
                                        <tr>
                                            <th style={{ width: '120px' }}>Date</th>
                                            <th>Description</th>
                                            <th style={{ width: '140px', textAlign: 'right' }}>Debit</th>
                                            <th style={{ width: '140px', textAlign: 'right' }}>Credit</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {payrollItems.map(item => (
                                            <AgentStatementRow
                                                item={item}
                                                key={item.id}
                                            />
                                        ))}
                                        {/*<tr style={{ fontSize: 16, height: '40px' }}>
                                            <td></td>
                                            <td style={{ paddingTop: 32, textAlign: 'right' }}>
                                                <b>Total</b>
                                            </td>
                                            <td style={{ paddingTop: 32, textAlign: 'right' }}>
                                                <b>
                                                    {toCurrency(
                                                        payrollItems
                                                            .filter(item => item.type == 'debit')
                                                            .reduce((acc, item) => acc + item.amount, 0),
                                                    )}
                                                </b>
                                            </td>
                                            <td style={{ paddingTop: 32, textAlign: 'right' }}>
                                                <b>
                                                    {toCurrency(
                                                        payrollItems
                                                            .filter(item => item.type == 'credit')
                                                            .reduce((acc, item) => acc + item.amount, 0),
                                                    )}
                                                </b>
                                            </td>
                                        </tr>*/}
                                    </tbody>
                                </Table>
                            ) : null}
                        </Box>
                    </td>
                </Box>
            )}
        </>
    )
}

export default function PayrollTab() {
    const { userId } = useParams<{ userId: string }>()
    const payrollApi = usePayrollApi(userId!)

    return (
        <Table hoverRow>
            <thead>
                <tr>
                    <th>Payroll Date</th>
                    <th>Credit</th>
                    <th>Debit</th>
                    <th>Balance</th>
                </tr>
            </thead>
            <tbody>
                {payrollApi.data?.map(payroll => (
                    <PayrollRow
                        key={payroll.id}
                        payroll={payroll}
                    />
                ))}
            </tbody>
        </Table>
    )
}
